import { MapPin, X } from "lucide-react";
import CustomMap from "./CustomMap";
import { useState } from "react";

const LocationCheckModal = ({ assessmentData, isOpen, setIsOpen }) => {
  const [maxDistance, setMaxDistance] = useState(null);
  const [showPolygon, setShowPolygon] = useState(false);

  // Transform assessment.uploads data to match CustomMap expected format
  const transformedUploads =
    assessmentData?.uploads?.map((upload, index) => ({
      id: index,
      lat: upload.lat || "-",
      longitude: upload.longitude || "-",
      picture: upload.picture || "",
      side: upload.side || upload.name || "unknown",
      created_at: new Date(upload.created_at || Date.now()),
    })) || [];

  return (
    <>
    
     

      {/* Bottom Modal */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0  bg-black bg-opacity-40 z-40 transition-opacity"
            onClick={() => setIsOpen(false)}
          />

          {/* Modal */}
          <div className="fixed inset-x-0 bottom-0 z-50 animate-slide-up mx-0 lg:mx-[10%]">
            <div className="bg-white rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-blue-600" />
                  </div>
                  <div className="text-left">
                    <h2 className="text-lg font-semibold text-gray-900">
                      Location Check
                    </h2>
                    {maxDistance && showPolygon && (
                      <p className="text-xs ">{maxDistance}</p>
                    )}
                  </div>
                </div>
                <div className="flex gap-2 ">
                  <label className="inline-flex items-center cursor-pointer border-r pe-4">
                    <input
                      type="checkbox"
                      checked={showPolygon}
                      onChange={() => setShowPolygon(!showPolygon)}
                      className="sr-only peer"
                    />
                    <div className="relative w-[2.4rem] h-5 bg-blue-500 rounded-full peer dark:bg-blue-500 peer-checked:after:translate-x-[18px] rtl:peer-checked:after:-translate-x-[18px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
                  </label>
                  <button
                    onClick={() => setIsOpen(false)}
                    className="w-11 h-11 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                  >
                    <X className="w-5 h-5 text-gray-500" />
                  </button>
                </div>
              </div>

              {/* Map Container */}
              <div className="flex-1 overflow-auto">
                <div className="h-[500px] w-full">
                  {/* Replace CustomMapPlaceholder with your actual CustomMap component */}
                  <CustomMap
                    uploaded={transformedUploads}
                    setMaxDistance={setMaxDistance}
                    showPolygon={showPolygon}
                    setShowPolygon={setShowPolygon}
                  />
                  {/* <CustomMap uploaded={transformedUploads} /> */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default LocationCheckModal;
